import useTranslation from '@/utils/hooks/translation/useTranslation';

/*
 * You have to pass the key directly (without namespace prefix)
 * Example:
 * const { t_error } = useErrorTranslation();
 * t_error('error_occured')
 */
const useErrorTranslation = () => {
    const { t } = useTranslation('errors');
    const t_error = (key, values = {}) => {
        return t(key, values) ?? t('error_occured', values);
    };

    return { t_error };
};

export default useErrorTranslation;
